import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=be837f2a&scoped=true&"
import script from "./TextAreaInput.vue?vue&type=script&lang=js&"
export * from "./TextAreaInput.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaInput.vue?vue&type=style&index=0&id=be837f2a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be837f2a",
  null
  
)

export default component.exports